module.exports = __webpack_public_path__ + "static/media/screen6.956796cd.png";